module.exports = __webpack_public_path__ + "static/media/banner-texture.4b7bba64.png";